import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  AlternativeStepperComponent,
  IStep,
} from '../../../../../components/ui/alternative-stepper/alternative-stepper.component';
import { SegmentInformationComponent } from '../../../../../components/organization/segments/segment-information/segment-information.component';
import { SegmentRuleComponent } from '../../../../../components/organization/segments/segment-rule/segment-rule.component';
import { SegmentReviewComponent } from '../../../../../components/organization/segments/segment-review/segment-review.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SegmentService } from '../../../../../services/segments/segment-service.service';
import { BackButtonComponent } from '../../../../../components/ui/back-button/back-button.component';

/** The three builder steps, shared by New segment and Edit segment. */
export const SEGMENT_STEPS: IStep[] = [
  { stepName: 'Name', stepQuery: 'information' },
  { stepName: 'Conditions', stepQuery: 'rule' },
  { stepName: 'Review', stepQuery: 'review' },
];

export const SEGMENT_STEP_COPY: Record<string, string> = {
  information: 'Name the segment so your team can find it when they send.',
  rule: 'Pick contacts by who they are. The segment updates as your contacts change.',
  review: 'Check the name and conditions, then save.',
};

@Component({
  selector: 'app-create-segment',
  standalone: true,
  imports: [
    AlternativeStepperComponent,
    SegmentInformationComponent,
    SegmentRuleComponent,
    SegmentReviewComponent,
    BackButtonComponent,
  ],
  templateUrl: './create-segment.component.html',
  styleUrl: './create-segment.component.css',
})
export class CreateSegmentComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private segmentService = inject(SegmentService);
  searchQuery!: string;

  steps: IStep[] = SEGMENT_STEPS;

  get description(): string {
    return SEGMENT_STEP_COPY[this.searchQuery] ?? SEGMENT_STEP_COPY['information'];
  }

  backToSegments() {
    this.segmentService.clearSegmentInformation();
    this.router.navigate(['organization', 'contacts', 'segmented-list']);
  }

  ngOnInit() {
    this.segmentService.startCreating();
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.searchQuery = params['title'];
    });
  }
}
